import { ILog } from '../../../global/types';
import { IServerResponse } from '../../../global/interfaces/server_response';
import { ErrorsDict, IFormErrorService } from '../../../global/services/form_error_service/form_error_service';
import { ICommand } from 'core-ts-types';

export interface IEnterEmailForm {
  email: string;
  google_captcha_response: string;
}

export interface IEnterEmailScope extends ng.IScope {
  enter_email: IEnterEmailForm;
}

export class EnterEmailController {
  public email: IEnterEmailForm;

  private errors: ErrorsDict;
  public validations: {
    email: RegExp;
  };

  constructor(
    private $state: ng.ui.IStateService,
    private $scope: IEnterEmailScope,
    private resetPasswordEmailCommand: ICommand,
    private formErrorService: IFormErrorService,
    private emailRegex: RegExp,
    private captchaWidgetDelegate: any,
    private log: ILog
  ) {
    this.email = {
      email: '',
      google_captcha_response: ''
    };
    this.validations = {
      email: this.emailRegex
    };
  }

  sendResetEmail(): void {
    this.errors = {};
    this.resetPasswordEmailCommand(this.email)
      .then(() => {
        this.log.user.success({
          content: `Email successfully submitted. Check your inbox for instructions to reset your password.`,
          timeout: 10000,
          dismissOnTimeout: true,
          dismissButton: true
        });
        this.$state.go('my.account');
      })
      .catch((res: any): any => {
        this.captchaWidgetDelegate.reset();
        this.errors = this.formErrorService(res.data!.error);
        return Promise.reject(res);
      });
  }

  cancel() {
    return this.$state.go('my.account');
  }
}

angular.module('capability-ng-user-app').controller('ngEnterEmailController', EnterEmailController);



// WEBPACK FOOTER //
// ./app/lib/user_app/views/enter_email/enter_email.ts